import React from "react";
import { getCustomMenu } from "../../../services/menuServices";
import { getItemsFromNavigation } from "../../../services/productListServices";
import { resloveUrlParams } from "../../../utils/Mobile/utils";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import cookie from "cookie";
import {
  DEFAULT_TEMPLATE_VERSION,
  PRODUCT_LIST_PAGE,
} from "@/utils/constants";
import DefaultProductListPage from "@/components/Default/ProductList/ProductListPage";
import WrapperContainer from "@/components/WrapperContainer";
import {setAxiosServerConfig} from "@/services/ApiCaller/apiCallerSSR";

const ProductListPage = ({
                           productsListData,
                           menuItems,
                           aboveMenuItems,
                           context,
                           showPreviousPage,
                           deviceType,
                           userAgent,
                           isCustomMenu,
                         }) => {
  return (
      <WrapperContainer context={context} templateVersion={deviceType}>
        <DefaultProductListPage
            {...{
              context,
              menuItems,
              productsListData,
              aboveMenuItems,
              deviceType,
              userAgent,
              isCustomMenu,
              showPreviousPage,
            }}
        />
      </WrapperContainer>
  );
};

export async function getServerSideProps(context) {
  setAxiosServerConfig(context.res)
  console.log("Request productList", context.req);
  const deviceType = DEFAULT_TEMPLATE_VERSION;
  console.log(
      "INFO",
      "Starting Server Side Rendering for the productList Page ..."
  );
  let query = context.query;
  let categoryID = query.id;
  let filters = query && query.filters ? query.filters : null;
  let PageIndex = null;
  let currentSort = null;
  let appliedFiltersValues = null;
  if (filters && filters.indexOf(".html") >= 0) {
    filters = filters.replace(".html", "");
  }
  if (query && query.PageIndex) {
    PageIndex = query.PageIndex;
  }
  if (filters) {
    filters = resloveUrlParams(filters);
    currentSort = filters.filter((element) => element.code === "SortBy");
    currentSort = currentSort && currentSort.length > 0 ? currentSort[0] : null;
    appliedFiltersValues = filters.filter(
        (element) => element.type === "Filters"
    );
    appliedFiltersValues = JSON.stringify(appliedFiltersValues);
  }
  const parsedCookies = context.req.headers.cookie
      ? cookie.parse(context.req.headers.cookie)
      : null;
  const shopCircleCookie =
      parsedCookies && parsedCookies.availabilityShopCircle
          ? parsedCookies.availabilityShopCircle
          : null;
  const userAgent = context.req.headers["user-agent"];
  const cUserID =
      parsedCookies && parsedCookies.CUserID ? parsedCookies.CUserID : "";
  const navigationToken =
      parsedCookies && parsedCookies.navigationToken ? parsedCookies.navigationToken : null;
  const productListInfos = await getItemsFromNavigation(
    deviceType,
    categoryID,
    PageIndex,
    currentSort,
    appliedFiltersValues,
    null,
    query,
    context.query?.KeyWords ?? null,
    shopCircleCookie,
    context.req.url.split('?')[0],
    "SSR",
    userAgent,
    cUserID,
    navigationToken,
    PRODUCT_LIST_PAGE,
  );
  let productsList = productListInfos.data;
  let menuData = [];
  let isCustomMenu = false;
  if (productsList.menuIdNav) {
    menuData = await getCustomMenu(
        deviceType,
        userAgent,
        productsList.menuIdNav.split(";"),
        false,
        cUserID,
        true,
        context.req.url
    );
    isCustomMenu = true;
  } else {
    menuData = await getCustomMenu(deviceType, userAgent, null, true, cUserID, true, context.req.url);
  }
  console.log("INFO", "Props has been prepared :)");
  return {
    props: {
      context: PRODUCT_LIST_PAGE,
      currentPage: PRODUCT_LIST_PAGE,
      menuItems: menuData.menuItems.values,
      showPreviousPage: PageIndex && PageIndex > 1 ? true : false,
      aboveMenuItems:menuData.aboveMenuItems.values,
      deviceType: deviceType,
      userAgent: userAgent,
      isCustomMenu: isCustomMenu,
      productsListData: productsList,
      currentIndex: PageIndex,
      sortBy: currentSort,
    },
  };
}

ProductListPage.propTypes = {
  context: PropTypes.string,
  mvcUrl: PropTypes.string,
};

ProductListPage.defaultProps = {};

export default connect(null, null)(ProductListPage);
